import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message,Select } from 'antd';
import Pagination from "react-js-pagination";

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import left from '../../assets/images/icon/next.png';
import right from '../../assets/images/icon/return.png';
import person from '../../assets/images/icon/person.png';
import add from '../../assets/images/icon/add.png';
import correct from '../../assets/images/icon/correct.png';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}
const item_name = [];
function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
  const item_name = checkedValues;
}

const { Search } = Input;
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			item_name: item_name,
			value: '',
			checkedList: defaultCheckedList,
			indeterminate: true,
			checkAll: false,
			school_list: [],
			student_list: [],
			fee_rem               :  0,
			followup_rem_staff    :  0,
			holiday_rem_parent    :  0,
			holiday_rem_staff     :  0,
			t_holiday_rem_parent  :  0,
			t_holiday_rem_staff   :  0,
			birthday_notify_parent:  0,
			birthday_rem_staff    :  0,
			t_birthday_remi_staff :  0,
			loading : false,
			loading2 : false,  
			offset: 0,
            perPage: 10,
            currentPage: 0,
            total_data: 0,        
            keyword: '',        
		}
		this.change_pagination = this.change_pagination.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleCheck = this.handleCheck.bind(this);	
		this.handleSubmit2 = this.handleSubmit2.bind(this);
	}
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
	}
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 school_id : storedArray['data'][0]['school_id'],
			});
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/reminder_settings_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							id: result['data'][0]['id'],
							fee_rem               : result['data'][0]['fee_rem'],
							followup_rem_staff    : result['data'][0]['followup_rem_staff'],
							holiday_rem_parent    : result['data'][0]['holiday_rem_parent'],
							holiday_rem_staff     : result['data'][0]['holiday_rem_staff'],
							t_holiday_rem_parent  : result['data'][0]['t_holiday_rem_parent'],
							t_holiday_rem_staff   : result['data'][0]['t_holiday_rem_staff'],
							birthday_notify_parent: result['data'][0]['birthday_notify_parent'],
							birthday_rem_staff    : result['data'][0]['birthday_rem_staff'],
							t_birthday_remi_staff : result['data'][0]['t_birthday_remi_staff'],
						});					
						
					}else{
						this.setState({
							school_list: [],
							
						});
					}		
					
				}
			});	

			var offset=this.state.offset;
			var per_page=this.state.perPage;
			var keyword = this.state.keyword;	
			
			var app2 = {user_id : user_id,school_id:school_id,offset:offset,per_page:per_page,keyword:keyword}
			getData('erp/all_student_list',app2).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_list: result['data'],
							total_data: result['total_data'],
						});	
						const details = result['data']
						const lenght_ = details.length;
						for (var i = 0; i < lenght_; i++) {	
						    if(result['data'][i]['allow_parent_notes']==1){   
							 document.getElementById('allow_parent_notes_'+i).checked = true;
							}
							
						    if(result['data'][i]['allow_profile_edit']==1){
							 document.getElementById('allow_profile_edit_'+i).checked = true;
							}
							
						    if(result['data'][i]['add_another_parents']==1){
							 document.getElementById('add_another_parents_'+i).checked = true;
							}
							
						    if(result['data'][i]['allow_video_download']==1){   
							 document.getElementById('allow_video_download_'+i).checked = true;
							}
						  
						}		
						
					}else{
						this.setState({
							student_list: [],
							total_data:0
							
						});
					}		
					
				}
			});				

						
	}
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });	
		setTimeout(() => {
					this.checkData();
			}, 100);
	};
  
  handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
		var app = {
			user_id: this.state.user_id,
			school_id: this.state.school_id,
			fee_rem: this.state.fee_rem,
			followup_rem_staff: this.state.followup_rem_staff,
			holiday_rem_parent: this.state.holiday_rem_parent,			
			holiday_rem_staff: this.state.holiday_rem_staff,			
			t_holiday_rem_parent: this.state.t_holiday_rem_parent,			
			t_holiday_rem_staff: this.state.t_holiday_rem_staff,			
			birthday_notify_parent: this.state.birthday_notify_parent,			
			birthday_rem_staff: this.state.birthday_rem_staff,			
			t_birthday_remi_staff: this.state.t_birthday_remi_staff,			
		}
	
      getData('erp/edit_reminder_settings',app).then((result) => {
      if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
			document.getElementById('loader').classList.remove('d-block');	
          }
		  if(result.status==200){			
				 this.setState({ loading: true });
				   message.config({ top: 150});
				   message.success('Reminder Settings Updated',2);
				   this.setState({ loading: false });
				   window.location.reload(false);				
		

          }
      });
	   
	  }else{
		message.error('Please Login',2);	
		document.getElementById('loader').classList.remove('d-block');	
	  }

  }
  
  	
  handleCheck(event) {
    const target = event.target;	
    let value;	
	if(target.checked){ value = 1;}	else{ value = 0;}	
    const name = target.name;
    this.setState({
      [name]: value
    });
	//alert(this.state.is_bookset);
  }
  
   handleSubmit2=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading2: true });
	
		var total_data_ = this.state.total_data;
		var perPage_ = this.state.perPage;
		if(total_data_>perPage_){
			var lenght = perPage_;
		}
		else{
			var lenght = total_data_;
		}
	   
	   	var student = [];
		for (var i = 0; i < lenght; i++) {
			 student[i]= document.getElementById('student_'+i).value; 
		}

	   var allow_parent_notes = [];
		for (var i = 0; i < lenght; i++) {
			 if (document.getElementById('allow_parent_notes_'+i).checked == true){
				allow_parent_notes[i]=1;
			 } else {
				allow_parent_notes[i]=0;
			 }
			 
		}
		var allow_profile_edit = [];
			for (var i = 0; i < lenght; i++) {
			 if (document.getElementById('allow_profile_edit_'+i).checked == true){
				allow_profile_edit[i]=1;
			 } else {
				allow_profile_edit[i]=0;
			 }
		}
        var add_another_parents = [];
			for (var i = 0; i < lenght; i++) {
			 if (document.getElementById('add_another_parents_'+i).checked == true){
				add_another_parents[i]=1;
			 } else {
				add_another_parents[i]=0;
			 }
		} 
		var allow_video_download = [];
			for (var i = 0; i < lenght; i++) {
			if (document.getElementById('allow_video_download_'+i).checked == true){
				allow_video_download[i]=1;
			 } else {
				allow_video_download[i]=0;
			 }
		}
		
	
	
		var app = {
			user_id: this.state.user_id,
			school_id: this.state.school_id,
			student: student,			
			allow_parent_notes: allow_parent_notes,			
			allow_profile_edit: allow_profile_edit,			
			add_another_parents: add_another_parents,			
			allow_video_download: allow_video_download,			
		}
	
      getData('erp/edit_student_configurations',app).then((result) => {
      if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading2: false });
			document.getElementById('loader').classList.remove('d-block');	
          }
		  if(result.status==200){			
				 this.setState({ loading2: true });
				   message.config({ top: 150});
				   message.success('Reminder Settings Updated',2);
				   this.setState({ loading2: false });
				   window.location.reload(false);				
		

          }
      });
	   
	  }else{
		message.error('Please Login',2);	
		document.getElementById('loader').classList.remove('d-block');	
	  }

  }
   
  
	
	onChange = checkedList => {
		this.setState({
		  checkedList,
		  indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
		  checkAll: checkedList.length === plainOptions.length,
		});
	  };

	onCheckAllChange = e => {
		this.setState({
		  checkedList: e.target.checked ? plainOptions : [],
		  indeterminate: false,
		  checkAll: e.target.checked,
		});
	  };
	  
	
	change_pagination(event){
		this.setState({
            perPage: event
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	} 
	handlePageChange(pageNumber) {
 
		const selectedPage = pageNumber;
		const xtra = parseInt(pageNumber) - 1 ;
        const offset = xtra * parseInt(this.state.perPage);
		
	    this.setState({
            currentPage: selectedPage,
            offset: offset,
			activePage:selectedPage,
        }, () => {
            this.checkData()
        });
	}
	 
	
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
		return (
			<div class="mobile_view">
			
	    <div id="main" class="bg-off">
         <div class="row">
		 
		 	<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Configurations</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                            <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Configurations
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
		 
            
		
		 	<div class="col s12 m12 ex-padd">	
            <div class="container staff-profile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food m0">
					<div class="children bg-blue notice configure iq-card2 flow-root">
                     
						<section class="invoice-list-wrapper section m0">
						<div class="col m12 bb ">
							<h5 class="center">Reminder Settings</h5>
						</div>
						<div class="mb-20 pb-20 add-notice bb">
							<div class="row">
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="fee_rem" value="1" checked={`${this.state.fee_rem==1?'checked':''}`}	 onChange={this.handleCheck} id="1" />
									<label for="1">Fee reminders -<span>Fee reminders will be sent to the parents leading up to the due date</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox"name="followup_rem_staff" value="1" checked={`${this.state.followup_rem_staff==1?'checked':''}`}	 onChange={this.handleCheck}   id="2" />
									<label for="2">Enquiry Followup reminder to staff -<span>Staff 'll be reminded with a notification about the enquiry followup that’s due</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="holiday_rem_parent" value="1" checked={`${this.state.holiday_rem_parent==1?'checked':''}`}	 onChange={this.handleCheck}  id="3" />
									<label for="3">Event/Holiday reminder to parent -<span>A notification is sent to remind about Today's Event/Holiday to parent</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="holiday_rem_staff" value="1" checked={`${this.state.holiday_rem_staff==1?'checked':''}`}	 onChange={this.handleCheck}   id="4" />
									<label for="4">Event/Holiday reminder to staff -<span>A notification is sent to remind about Today's Event/Holiday to staff</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="t_holiday_rem_parent" value="1" checked={`${this.state.t_holiday_rem_parent==1?'checked':''}`}	 onChange={this.handleCheck}   id="5" />
									<label for="5">Tomorrow's Event/Holiday reminder to parent -<span>A notification is sent to remind about Tomorrow's Event/Holiday to parent</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="t_holiday_rem_staff" value="1" checked={`${this.state.t_holiday_rem_staff==1?'checked':''}`}	 onChange={this.handleCheck}   id="6" />
									<label for="6">Tomorrow's Event/Holiday reminder to staff -<span>A notification is sent to remind about Tomorrow's Event/Holiday to staff</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="birthday_notify_parent" value="1" checked={`${this.state.birthday_notify_parent==1?'checked':''}`}	 onChange={this.handleCheck}   id="7" />
									<label for="7">Birthday notification to parent -<span>Birthday wishes are sent as a notification to parent</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="birthday_rem_staff" value="1" checked={`${this.state.birthday_rem_staff==1?'checked':''}`}	 onChange={this.handleCheck}   id="8" />
									<label for="8">Birthday reminder to staff -<span>Birthday reminder to all the staff of that child's class</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<input type="checkbox" name="t_birthday_remi_staff" value="1" checked={`${this.state.t_birthday_remi_staff==1?'checked':''}`}	 onChange={this.handleCheck}  id="10" />
									<label for="10">Tomorrow's Birthday reminder to staff -<span>Tomorrow's Birthday reminder to all the staff of that child's class</span></label>
								</div>
								<div class="col m12  mt-10 right">
									 <Button className="snd-btn mb-20" onClick={this.handleSubmit} loading={this.state.loading}>Update</Button>
								</div>
								
							</div>
						</div>	
						
						<div class="mb-20 pb-20 add-notice">
							<div class="row">
								<div class="col m12 mt-10  ">
									<img src={correct} class="conf-img"/>
									<label for="1">Parent Notes -<span>Setting to allow/restrict parents to send notes to school</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<img src={correct} class="conf-img"/>
									<label for="1">Profile Edit -<span>This allows the parents to edit their child's profile info except the parent's phone number</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<img src={correct} class="conf-img"/>
									<label for="1">Add more Parents -<span>Parents can add one or two more parents (max. of 3 for a child)</span></label>
								</div>
								<div class="col m12 mt-10  ">
									<img src={correct} class="conf-img"/>
									<label for="1">Allow video download -<span>Parents can download/share the video that you have sent them</span></label>
								</div>
							</div>
						</div>	
						<div class="responsive-table add-notice hidden-xs">
						<div class="row">
						<div class="col m10 mt-10 view-Profile ">
							<Search placeholder="Search by Child Name"  onChange={this.handleSizeChange}  name="keyword" />
						</div>
						<div class="col m2 mt-10 view-Profile pt-10">
							<Button className="snd-btn"  onClick={this.handleSubmit2} loading={this.state.loading2}>Update</Button>
						</div>
						</div>
						<div class="dataTables_wrapper responsive-table no-footer">
						
							<table class="table white border-radius-4 table_border">
							  <thead>
								<tr>
								  <th><span>Sl No.</span></th>
								  <th>Profile Pic</th>
								  <th>Child Name</th>
								  <th>Program</th>
								  <th>Allow Parent Notes</th>
								  <th>Allow Profile Edit</th>
								  <th>Add Another Parents</th>
								  <th>Allow Video Download</th>
								  
								</tr>
							  </thead>

							  <tbody>
							 {this.state.student_list.map((list,index) => (
								<tr>
								  <td>{list.sl_no} <input type="hidden" value={list.id} name={`student_${index}`} id={`student_${index}`}/></td>
								  <td><img src={person} class="conf-profile-img"/></td>
								  <td><span class="invoice-amount">{list.first_name} {list.last_name}</span></td>
								  <td>{list.program_name}</td>
								  <td><input type="checkbox" value="1" name={`allow_parent_notes_${index}`} id={`allow_parent_notes_${index}`} /></td>
								  <td><input type="checkbox" value="1"  name={`allow_profile_edit_${index}`} id={`allow_profile_edit_${index}`} /></td>
								  <td><input type="checkbox" value="1"  name={`add_another_parents_${index}`} id={`add_another_parents_${index}`}/></td>
								  <td><input type="checkbox" value="1" name={`allow_video_download_${index}`} id={`allow_video_download_${index}`}/></td>
								  
								</tr>
								))}
								{(() => {  
								if (this.state.student_list.length =='0') {
								return (
								<td id="error" class="center" colspan="12">No Data Found</td>
									)
									}
								})()}
							  </tbody>
							</table>
							
							
									    {(() => {
					if (this.state.student_list.length>0) {
						return (
							<>
							 <div class="right hidden-mobile">
							  <Pagination
								  activePage={this.state.activePage}
								  itemsCountPerPage={this.state.perPage}
								  totalItemsCount={this.state.total_data}
								  pageRangeDisplayed={5}
								  onChange={this.handlePageChange.bind(this)}
								/>
						   
						   </div>	
						   <div class="right mt-20 mr-10 hidden-mobile"> 
								<Select onChange={this.change_pagination} value={this.state.perPage}>
										<Select.Option value="10">10</Select.Option>
										<Select.Option value="20">20</Select.Option>
										<Select.Option value="50">50</Select.Option>
										<Select.Option value="100">100</Select.Option>
								</Select>
					     </div>

						</>
						)
					}
				})()}		
							
						</div>
						</div>
						</section>
						
						
					</div>	
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
